<template>
  <div>
    <form @submit.prevent="submitForm">
      <DynamicForm
        :schema="schema"
        v-model="form"
        @status="saveStatus"
        ref="dynamicForm"
      />
    </form>
  </div>
</template>
<script>
import store from "../store.js";
import DynamicForm from "./DynamicForm";

export default {
  name: "StepForm2",
  components: { DynamicForm },
  props: {
    // step: Number,
    clickedNext: Boolean,
    currentStep: {},
  },
  data() {
    return {
      store,
      schema: {},
      form: {},
      status: null,
      miV: {},
      content: document.getElementsByClassName("content")[0],
      contentOriginaMinHeight: null,
      contentChangedMinHeight: "400px",
    };
  },
  async mounted() {
    // hack para establecer el min-height del content y que la lista de productos se visualice correctamente
    this.contentOriginaMinHeight = this.content.style.minHeight;
    // console.log("min-height = ", this.contentOriginaMinHeight);
    this.content.style.minHeight = this.contentChangedMinHeight;

    if (this.$store.state.step >= 0) {
      await this.loadFields(this.$i18n.locale, this.$store.state.idStep);
    } else {
      await this.loadFields(this.$i18n.locale, 2);
    }
    this.miV = this.$refs.dynamicForm.$v;
  },
  watch: {
    // para que cargue los campos con el lang correcto
    "$i18n.locale": function () {
      // Para actualizar el locale en el store (para fechas)
      //this.$store.state.interfaseLang = this.$i18n.locale
      // console.log(this.$i18n.locale)
      this.loadFields(this.$i18n.locale, this.$store.state.idStep);
    },
    miV: {
      handler: function (val) {
        if (!val.$invalid) {
          //Aquí tiene que mandar cada campo del form para que se agregue al objeto form del parent
          this.$emit("can-continue", { value: true });

          var extendedForm = [];
          for (const [key, value] of Object.entries(this.schema)) {
            var extendedField = {};
            Object.defineProperty(extendedField, "fid", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: value.idField,
            });
            Object.defineProperty(extendedField, "fname", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: key,
            });
            Object.defineProperty(extendedField, "fvalue", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: this.form[key],
            });
            extendedForm.push(extendedField);
          }
          store.commit("appendToRegForm", extendedForm);
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.miV.form.$touch();
      }
    },
  },
  // methods: {
  //   async loadFields(lang, step) {
  //     var that = this;
  //     const axios = require("axios"); // eslint-disable-line
  //     var url = this.$websiteFront + "/api/json-reg-fields-v1.php"; //"https://globiz.com/api/json-reg-fields-v1.php"
  //     axios
  //       .post(url, {
  //         dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
  //         appid: 1,
  //         lang: lang,
  //         ide: that.$route.params.ide,
  //         pli: that.$route.params.pli,
  //         gid: that.store.state.usr.gid,
  //         step: step,
  //       })
  //       .then(function (response) {
  //         if (response.data) {
  //           that.schema = response.data.fields;
  //           if (response.data.valoresdef) {
  //             that.form = response.data.valoresdef;
  //           }
  //         } else {
  //           console.log("Error en carga de campos");
  //         }
  //       })
  //       .catch((error) => {
  //         if (error.response) {
  //           console.error("Respuesta del servidor:", error.response);
  //         } else if (error.request) {
  //           console.error("No hubo respuesta del servidor:", error.request);
  //         } else {
  //           console.error(
  //             "Error en la configuración de la solicitud:",
  //             error.message
  //           );
  //         }
  //       });
  //   },
  //   saveStatus(status) {
  //     this.status = status;
  //   },
  // },
  methods: {
  async loadFields(lang, step) {
    var that = this;
    const axios = require("axios"); // eslint-disable-line
    var url = this.$websiteFront + "/api/json-reg-fields-v1.php";
    let retries = 3; // Número de intentos
    let delay = 400; // Intervalo entre intentos en ms

    // Función para esperar un tiempo (delay)
    function delayFunction(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Función para intentar la solicitud
    async function tryRequest() {
      try {
        const response = await axios.post(url, {
          dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
          appid: 1,
          lang: lang,
          ide: that.$route.params.ide,
          pli: that.$route.params.pli,
          gid: that.store.state.usr.gid,
          step: step,
        });

        if (response.data) {
          that.schema = response.data.fields;
          if (response.data.valoresdef) {
            that.form = response.data.valoresdef;
          }
        } else {
          console.log("Error en carga de campos");
        }
      } catch (error) {
        if (error.code === 'ERR_HTTP2_PROTOCOL_ERROR' && retries > 0) {
          console.log(`Intento fallido. Reintentando... (Quedan ${retries} intentos)`);
          retries -= 1;
          await delayFunction(delay); // Espera antes de reintentar
          tryRequest(); // Vuelve a intentar
        } else {
          if (error.response) {
            console.error("Respuesta del servidor:", error.response);
          } else if (error.request) {
            console.error("No hubo respuesta del servidor:", error.request);
          } else {
            console.error("Error en la configuración de la solicitud:", error.message);
          }
        }
      }
    }

    // Llamar a la función de intento
    tryRequest();
  },

  saveStatus(status) {
    this.status = status;
  },
},

  beforeDestroy() {
    // esto me parece que no está funcionando. la idea era volver el min-height al original
    this.content.style.minHeight = "100px"; //this.contentOriginaMinHeight;
  },
};
</script>
<style scoped>
/* para que la lista de productos se vea más ancha */
form {
  max-width: 86%;
}
</style>